export default async function <T>(
    input: RequestInfo,
    init?: RequestInit
): Promise<T> {
    const response = await fetch(input, init);

    if (response.ok) {
        return await response.json().catch(() => ({}));
    }

    try {
        const errorData = await response.json();
        return Promise.reject(errorData);
    } catch (error) {
        return Promise.reject({
            Message: response.statusText,
            StatusCode: response.status
        });
    }
}
